import React, { Component } from "react"
import { translate } from "react-translate"
import { Segment, Button } from "semantic-ui-react"
import "./FiltreDevis.css"
import FiltreStatut from "./FiltreStatut"
import BtnAppliquer from "./BtnAppliquer"
import DuoDatePicker from "./DuoDatePicker"

class FiltreDevis extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    let { t } = this.props
    var filterCallback = this.props.filter
    var { activeFilters } = this.props
    return (
      <Segment id="blocFiltre">
        {" "}
        <div id="groupBouttonType">

          <p id="nameType">{t("label_choice_devis_facture")}</p>

          <div id="groupBouttonsType">
          <Button
            id="bouttonType"
            className="devisBtn"
            onClick={() => filterCallback("devis")}
            active={activeFilters.indexOf("devis") > -1}
          >
            {t("label_button_devis")}{" "}
          </Button>
          <Button
            id="bouttonType"
            className="factureBtn"
            onClick={() => filterCallback("facture")}
            active={activeFilters.indexOf("facture") > -1}
          >
            {t("label_button_facture")}
          </Button>
          </div>

          <FiltreStatut
            handleDropdownChange={this.props.handleDropdownChange}
          />

          <div id="groupBouttonTypeDate">
          <p id="PeriodeDatePicker">{t("label_datepicker_1")} </p>
          <DuoDatePicker
            id="datePicker"
            type="date"
            date="2018-08-06"
            value={this.state.date}
            onChange={(e, val) => this.setState({ date: val.value })}
          />
          <p id="OuDatePicker">{t("label_datepicker_2")} </p>
          <DuoDatePicker
            id="datePicker"
            type="date"
            date="2018-08-16"
            onChange={(e, val) => this.setState({ date: val.value })}
          />
          </div>
          <BtnAppliquer />
        </div>
      </Segment>
    )
  }
}

export default translate("ProEnteteDevisFilter")(FiltreDevis)



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/FiltreDevis.js